import { render, staticRenderFns } from "./ButtonAdditionalInfo.vue?vue&type=template&id=bde7fa3a"
import script from "./ButtonAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./ButtonAdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports